import { configureStore } from "@reduxjs/toolkit";
import { appSlice } from "./app";
import { StoreType } from "./storeTypes";

export default configureStore<StoreType>({
  reducer: {
    app: appSlice.reducer,
  },
});
